import { useContext } from "react";

import { SessionSurveyContext } from "@/modules/session-survey/context/SessionSurveyContext";

export const useSessionSurveyContext = () => {
  const context = useContext(SessionSurveyContext);

  if (!context) {
    throw new Error(
      "useSessionSurveyContext must be used within a SessionSurveyProvider",
    );
  }

  return context;
};
